import { useAuth } from "@/hooks/useAuth";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import { EmptyState } from "@ir/ui";
import { ReactNode, useEffect } from "react";

const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading, error, setAuth } = useAuth();

  useEffect(() => {
    setAuth();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <EmptyState title="Something went wrong while checking if you are authenticated" description={error.message} />;
  }

  return children;
};

export default AuthProvider;
